import React from "react";
import NewNavbar from "../../Components/newNavbar/NewNavbar";
import Footer from "../../Components/footer/Footer";
import CompanyImage from "../../assets/evacassets/image/CompanyImage.png";
import OutSideNavBar from "../outsideNavBar/OutSideNavBar";

const AboutUs = () => {
  return (
    <div className="bg-white">
      <OutSideNavBar />

      <div className=" custom-container  my-5">
        <div className="row d-flex flex-column-reverse flex-lg-row align-items-center">
          <div className="col-lg-7 text-start mt-4 mt-lg-0">
            <h2 className="fw-bold mb-3">About Us</h2>
            <br />
            <h4 className="fw-semibold mb-3">
              Pyramid Electronics can trace its roots to the early days of power
              electronics in India
            </h4>
            <p style={{ color: "#595959", lineHeight: "1.7" }}>
              Pyramid Electronics was founded in 1993 to manufacture stand-alone
              UPS systems and domestic inverters in Panchkula, Haryana, India.
              In 2004, Pyramid started the second unit in Himachal Pradesh to
              enhance the production capacity. Pyramid designs are backed by
              over 20 years of field experience and thousands of installations
              across India. A solid blend of experienced personnel, the latest
              design techniques, and engineering skills helps us ensure superior
              power conversion products. The test and inspection departments are
              equipped with all modern test facilities. Presently, the company
              mainly focuses on the following power conditioning products: Grid
              Tied Solar Inverters (3KW-50KW), EV Chargers (7.4KW-50KW) and
              Online UPS (5KW-120KW).
            </p>

            <div className="d-flex flex-wrap gap-5 mt-5">
              <div>
                <h3 className="fw-bold">30+</h3>
                <p className="mb-0" style={{ color: "#595959" }}>
                  Years Experience
                </p>
              </div>
              <div>
                <h3 className="fw-bold">100%</h3>
                <p className="mb-0" style={{ color: "#595959" }}>
                  Quality Focus
                </p>
              </div>
              <div>
                <h3 className="fw-bold">150+</h3>
                <p className="mb-0" style={{ color: "#595959" }}>
                  Employees
                </p>
              </div>
            </div>
          </div>

          {/* Right: Image (shown first on mobile) */}
          {/* <div className="col-lg-5 text-center mb-4 mb-lg-0">
            <img
              src={CompanyImage}
              alt="Pyramid Electronics Building"
              className="img-fluid rounded shadow"
              style={{
                maxHeight: "350px",
                objectFit: "cover",
                borderRadius: "16px",
              }}
            />
          </div> */}
          <div className="col-lg-5 d-flex justify-content-center mb-4 mb-lg-0">
            <img
              src={CompanyImage}
              alt="Pyramid Electronics Building"
              className="img-fluid rounded shadow"
              style={{
                maxHeight: "350px",
                objectFit: "cover",
                borderRadius: "16px",
              }}
            />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default AboutUs;
